export default function clampMinZero(value) {
  const num = Number(value);
  if (Number.isNaN(num)) return 0;
  return Math.max(0, num);
}
